// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===========  Checkbox / Radio  ============= */
.FF_PreviewFields_checkbox_1QFFM,
.FF_PreviewFields_radio_pRzzL {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  width: 100%;
}
.FF_PreviewFields_checkboxGroup_Y5ixx,
.FF_PreviewFields_radioGroup_qBR13 {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  width: 100%;
  align-items: stretch;
}
/* Horizontal layout behavior:
   - 2 columns when there is room
   - 1 column as soon as 2-up can't fit (min-width forces wrap)
   - never becomes 3+ columns (basis is 50%)
*/
.FF_PreviewFields_checkboxGroup__isHorizontal_UbnHM .FF_PreviewFields_checkboxItem_u7V\\+M,
.FF_PreviewFields_radioGroup__isHorizontal_lOch- .FF_PreviewFields_radioItem_b2ito {
  flex: 1 1 calc(50% - 0.25rem); /* 2 columns with a 0.5rem gap */
  min-width: 16.25rem;
  max-width: 100%;
}
/* Make sure the items can actually shrink/grow inside the flex row */
.FF_PreviewFields_checkboxItem_u7V\\+M,
.FF_PreviewFields_radioItem_b2ito {
  min-width: 0;
}
.FF_PreviewFields_radioItem_b2ito {
  display: flex;
  flex-direction: column;
  justify-content: stretch;
  height: min-content;
  width: auto;
}
.FF_PreviewFields_checkboxItem_u7V\\+M {
  display: flex; /* ensure it’s a flex item internally */
  flex-direction: row;
  justify-content: space-between;
  padding: 0.75rem 1rem;
}
/* Ignore vertical for now, but keeping this won't hurt */
.FF_PreviewFields_checkboxGroup__isVertical_yicQE .FF_PreviewFields_checkboxItem_u7V\\+M,
.FF_PreviewFields_radioGroup__isVertical_GwOdJ .FF_PreviewFields_radioItem_b2ito {
  min-width: 100%;
  flex-basis: 100%;
}

/* ===========  SingleSelect / MultiSelect  ============= */
.FF_PreviewFields_singleSelect_lF-nM,
.FF_PreviewFields_multiSelect_-dX\\+o {
  width: 100%;
}
.FF_PreviewFields_singleSelectDropdown_tYbHl,
.FF_PreviewFields_multiSelectDropdown_D3MaO {
  max-height: 20rem;
  z-index: 1350;
}

/* ===========  Spacer  ============= */
.FF_PreviewFields_spacer_BX2F6 {
  width: 100%;
  display: block;
}

/* ===========  Boolean Switch  ============= */
.FF_PreviewFields_booleanSwitch_H\\+CDv {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  width: 100%;
}
.FF_PreviewFields_booleanSwitchControl_HR-Cj {
  width: min-content;
}

/* ===========  Password  ============= */
.FF_PreviewFields_password_mV35V {
  display: flex;
  align-items: flex-start;
  gap: 1.5rem;
  width: 100%;
}
.FF_PreviewFields_passwordFieldWrapper_e\\+Ai2 {
  flex: 1 1 0;
  min-width: 0;
}

/* ===========  Sensitive  ============= */
.FF_PreviewFields_datePickerRoot_UtOFi {
  width: 100%;
}

/* ===========  Sensitive  ============= */
.FF_PreviewFields_sensitiveFieldWrapper_VEGnv {
  width: 100%;
}

/* ===========  Terms and Conditions  ============= */
.FF_PreviewFields_termsAndConditions_pz-9l {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  width: 100%;
}
.FF_PreviewFields_termsAndConditionsCheckbox_nTWnQ {
  justify-content: flex-end;
  width: 100%;
  min-height: 3.125rem;
  height: auto;
}
.FF_PreviewFields_termsAndConditionsTermsTextWrapper_H4jBm {
  width: 100%;
}
.FF_PreviewFields_tncMessage_NERNW {
  display: inline;
}
/* Modal related T&C */
.FF_PreviewFields_termsAndConditionsModal_5yoii {
  width: 50rem;
  max-width: calc(100vw - 4rem);
}
.FF_PreviewFields_termsAndConditionsBody_QyvSr {
  display: flex;
  flex-direction: column;
  min-height: 22.5rem;
  padding: 1.5rem;
}
.FF_PreviewFields_termsAndConditionsBody_QyvSr .SaviyntRenderQuillDelta .ql-editor {
  background: var(--color-background-neutral-subtlest, #fff);
  border-radius: var(--border-radius-xs, 0.25rem);
  padding: 1.5rem;
}
.FF_PreviewFields_termsAndConditionsEmptyDelta_Z-03z {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin: auto 0;
}
.FF_PreviewFields_termsAndConditionsHeader_QUDY\\+ {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 1.5rem 1rem 1.5rem 3rem;
  background: var(--color-background-neutral-subtlest, #fff);
  border-bottom: 1px solid var(--color-border-neutral-decorative, #ebecf2);
  border-radius: var(--border-radius-xs, 0.25rem)
    var(--border-radius-xs, 0.25rem) 0 0;
}
.FF_PreviewFields_termsAndConditionsHeaderTitle_Xj7Hj {
  margin: 0;
  color: var(--color-foreground-neutral-bold, #212328);
}
.FF_PreviewFields_termsAndConditionsFooter_dG\\+qU {
  justify-content: flex-end;
  gap: 0.5rem;
}

/* Mobile drawer variant (ModalIsland isMobileWidth) */
@media (max-width: 599px) {
  .FF_PreviewFields_termsAndConditionsModal_5yoii {
    width: 100vw;
    max-width: 100vw;
  }
  .FF_PreviewFields_termsAndConditionsHeader_QUDY\\+ {
    padding: 1rem 1rem 1rem 1.5rem;
    border-radius: 0;
    border-bottom: none;
    background: transparent;
  }
  .FF_PreviewFields_termsAndConditionsBody_QyvSr {
    min-height: 50vh;
    max-height: none;
    padding: 0;
    background: transparent;
  }
  .FF_PreviewFields_termsAndConditionsBody_QyvSr
    .SaviyntRenderQuillDelta
    .ql-editor {
    background: transparent;
    border-radius: 0;
    padding: 1.5rem;
  }
}

/* ===========  Captcha  ============= */
.FF_PreviewFields_captcha_d\\+stn {
  position: relative;
  display: block;
  width: 100%;
  min-height: 4.5rem;
}
.FF_PreviewFields_captchaWidgetOverlay_Pe1qd {
  position: absolute;
  inset: 0;
}

/* ===========  Read-Only Field Value  ============= */
.FF_PreviewFields_value__isReadOnly_JnWYE:disabled {
  color: var(--color-foreground-neutral-medium, #4a4c59);
}

/* MenuInput responsive heights -- Breakpoint Vars are not working for the heights */
@media (max-height: 899px) {
  .FF_PreviewFields_singleSelectDropdown_tYbHl,
  .FF_PreviewFields_multiSelectDropdown_D3MaO {
    max-height: 16rem;
  }
}
/* @media (max-height: 767px) {
  .singleSelectDropdown,
  .multiSelectDropdown {
    max-height: 10rem;
  }
}
@media (max-height: 599px) {
  .singleSelectDropdown,
  .multiSelectDropdown {
    max-height: 6.75rem;
  }
} */
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"checkbox": `FF_PreviewFields_checkbox_1QFFM`,
	"radio": `FF_PreviewFields_radio_pRzzL`,
	"checkboxGroup": `FF_PreviewFields_checkboxGroup_Y5ixx`,
	"radioGroup": `FF_PreviewFields_radioGroup_qBR13`,
	"checkboxGroup__isHorizontal": `FF_PreviewFields_checkboxGroup__isHorizontal_UbnHM`,
	"checkboxItem": `FF_PreviewFields_checkboxItem_u7V+M`,
	"radioGroup__isHorizontal": `FF_PreviewFields_radioGroup__isHorizontal_lOch-`,
	"radioItem": `FF_PreviewFields_radioItem_b2ito`,
	"checkboxGroup__isVertical": `FF_PreviewFields_checkboxGroup__isVertical_yicQE`,
	"radioGroup__isVertical": `FF_PreviewFields_radioGroup__isVertical_GwOdJ`,
	"singleSelect": `FF_PreviewFields_singleSelect_lF-nM`,
	"multiSelect": `FF_PreviewFields_multiSelect_-dX+o`,
	"singleSelectDropdown": `FF_PreviewFields_singleSelectDropdown_tYbHl`,
	"multiSelectDropdown": `FF_PreviewFields_multiSelectDropdown_D3MaO`,
	"spacer": `FF_PreviewFields_spacer_BX2F6`,
	"booleanSwitch": `FF_PreviewFields_booleanSwitch_H+CDv`,
	"booleanSwitchControl": `FF_PreviewFields_booleanSwitchControl_HR-Cj`,
	"password": `FF_PreviewFields_password_mV35V`,
	"passwordFieldWrapper": `FF_PreviewFields_passwordFieldWrapper_e+Ai2`,
	"datePickerRoot": `FF_PreviewFields_datePickerRoot_UtOFi`,
	"sensitiveFieldWrapper": `FF_PreviewFields_sensitiveFieldWrapper_VEGnv`,
	"termsAndConditions": `FF_PreviewFields_termsAndConditions_pz-9l`,
	"termsAndConditionsCheckbox": `FF_PreviewFields_termsAndConditionsCheckbox_nTWnQ`,
	"termsAndConditionsTermsTextWrapper": `FF_PreviewFields_termsAndConditionsTermsTextWrapper_H4jBm`,
	"tncMessage": `FF_PreviewFields_tncMessage_NERNW`,
	"termsAndConditionsModal": `FF_PreviewFields_termsAndConditionsModal_5yoii`,
	"termsAndConditionsBody": `FF_PreviewFields_termsAndConditionsBody_QyvSr`,
	"termsAndConditionsEmptyDelta": `FF_PreviewFields_termsAndConditionsEmptyDelta_Z-03z`,
	"termsAndConditionsHeader": `FF_PreviewFields_termsAndConditionsHeader_QUDY+`,
	"termsAndConditionsHeaderTitle": `FF_PreviewFields_termsAndConditionsHeaderTitle_Xj7Hj`,
	"termsAndConditionsFooter": `FF_PreviewFields_termsAndConditionsFooter_dG+qU`,
	"captcha": `FF_PreviewFields_captcha_d+stn`,
	"captchaWidgetOverlay": `FF_PreviewFields_captchaWidgetOverlay_Pe1qd`,
	"value__isReadOnly": `FF_PreviewFields_value__isReadOnly_JnWYE`
};
export default ___CSS_LOADER_EXPORT___;
